function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M3.78885 7.10546L11.5528 3.22349C11.8343 3.08273 12.1657 3.08273 12.4472 3.22349L20.2111 7.10546C21.155 7.57737 20.8192 8.99989 19.7639 8.99989H4.23607C3.18084 8.99989 2.84503 7.57737 3.78885 7.10546Z",
  fill: "black"
});

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 18.9999L6 10.9999H8L8 18.9999H11V10.9999H13L13 18.9999H16V10.9999H18L18 18.9999H20C20.5523 18.9999 21 19.4476 21 19.9999C21 20.5522 20.5523 20.9999 20 20.9999H4C3.44772 20.9999 3 20.5522 3 19.9999C3 19.4476 3.44772 18.9999 4 18.9999H6Z",
  fill: "black"
});

var SvgBank = function SvgBank(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      height: "100px",
      width: "100px",
      viewBox: "0 0 24 24",
      fill: "none",
      x: "0px",
      y: "0px"
    }, props), _ref, _ref2)
  );
};

export default SvgBank;